// generated from 475 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const channelEngagementFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("channel_engagement_filter"),
  comparison_key: z.enum([
    "3", // 449 (94.53%)
    "12", // 15 (3.16%)
    "5", // 11 (2.32%)
  ]),
  display_name: z.enum([
    "Email", // 423 (89.05%)
    "Mobile push", // 47 (9.89%)
    "SMS", // 5 (1.05%)
    // ChannelEngagementFilter::CHANNELS includes web push (ChannelRank.human_readable)
    "Web push",
  ]),
  // undefined: 258 (54.32%), defined 217 (45.68%)
  // avg: 42.67, min: 0, max: 90
  raw_value: z.int().min(0).optional(),
  // avg: 38.26, min: 0, max: 100
  value: z.int().min(0).max(100),
  varies_by_app_group: z.literal(false),
});
